<template>
  <div>
    <div class="columns is-multiline" v-if="currentStep === 'Unterkonstruktion'">
        <div class="column is-12">
            <div class="buttons is-pulled-right">
                <button class="button is-cornered is-size-5" @click="chooseMaterial">Nächster Schritt</button>
            </div>
        </div>
    </div>
    <div class="columns is-multiline" v-if="currentStep === 'Material'">
        <div class="column is-6">
            <div class="buttons">
                <button class="button is-cornered has-background-grey is-size-5" @click="chooseUnterkonstruktion">Schritt zurück</button>
            </div>
        </div>
        <div class="column is-6">
            <div class="buttons is-pulled-right">
                <button class="button is-cornered is-size-5" @click="chooseSchraubenart">Nächster Schritt</button>
            </div>
        </div>
    </div>
    <div class="columns is-multiline" v-if="currentStep === 'Schraubenart'">
        <div class="column is-6">
            <div class="buttons">
                <button class="button is-cornered has-background-grey is-size-5" @click="chooseMaterial">Schritt zurück</button>
            </div>
        </div>
        <div class="column is-6">
            <div class="buttons is-pulled-right">
                <button class="button is-cornered is-size-5" @click="chooseProduct">Nächster Schritt</button>
            </div>
        </div>
    </div>
    <div class="columns is-multiline" v-if="currentStep === 'Produkte' && !currentProduct">
        <div class="column is-6">
            <div class="buttons">
                <button class="button is-cornered has-background-grey is-size-5" @click="chooseSchraubenart">Schritt zurück</button>
            </div>
        </div>
    </div>
    <div class="columns is-multiline" v-if="currentProduct && currentStep != 'Summary'">
        <div class="column is-6">
            <div class="buttons">
                <button class="button is-cornered has-background-grey is-size-5" @click="chooseProduct">Schritt zurück</button>
            </div>
        </div>
        <div class="column is-6" v-if="currentProduct && hasItemsInCart && currentStep != 'Summary'">
            <div class="buttons is-pulled-right">
                <button class="button is-cornered is-size-5" @click="Summary">Nächster Schritt</button>
            </div>
        </div>
    </div>
    <div class="columns is-multiline" v-if="currentStep === 'Summary'">
        <div class="column is-6">
            <div class="buttons">
                <button class="button is-cornered has-background-grey is-size-5" @click="productDetail">Schritt zurück</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
     data() {
        return {
            nothingSelected: 'Bitte wählen Sie eine Option'
        }
    },
    computed: {
        hasItemsInCart () {
            return this.$store.state.cart.length > 0
        },
        currentStep: {
            set (val) {
                this.$store.commit('setCurrentStep', val)
            },
            get () {
                return this.$store.state.currentStep
            }
        },
        currentProduct: {
                set (val) {
                    this.$store.commit('setCurrentProduct', val)
                },
                get () {
                    return this.$store.state.currentProduct
                }
            },
        categories () {
            return this.$store.state.categories
        },
        categoryUnterkonstruktion () {
            return this.categories.filter(cat => cat.parent === this.categoryIdUnterkonstruktion)
        },
        categoryMaterial () {
            return this.categories.filter(cat => cat.parent === this.categoryIdMaterial)
        },
        categorySchraubenart () {
            return this.categories.filter(cat => cat.parent === this.categoryIdSchraubenart)
        }
        
    },
  methods: {
    chooseMaterial () {
        this.currentStep = 'Material'
    },
    chooseUnterkonstruktion () {
        this.currentStep = 'Unterkonstruktion'
    },
    chooseSchraubenart () {
        this.currentStep = 'Schraubenart'
    },
    chooseProduct () {
        this.currentProduct = null
        this.currentStep = 'Produkte'
    },
    productDetail () {
        this.currentStep = 'ProductDetails'
    },
    Summary () {
        this.currentStep = 'Summary'
    },
  }
}
</script>

<style lang="sass" scoped>
@import "../assets/sass/variables.sass"


.button
    text-transform: uppercase
    background-color: $primary
    color: $grey-lighter
    font-size: 30px

</style>